import React, { useState, useEffect } from "react";
import "./Header.css";
import CustomButton from "./Button2";
const Header = ({ onLogout }) => {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const storedUserDetails = localStorage.getItem("userDetails");
    if (storedUserDetails) {
      const parsedDetails = JSON.parse(storedUserDetails);
      setUserName(parsedDetails.name || "User");
    }
  }, []);

  return (
    <header className="dashboard-header">
      <div className="header-title">
        <h1>Achievement Report Dashboard</h1>
      </div>
      
      <div className="header-user">
        <span>Welcome, {userName}</span>
        <button className="logout-button" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
